import { ErrorCode, InitiateInstallmentPaymentResponse, OrderResponse, OverduePaymentResponse } from '@afterpaytouch/portal-api'
import { ReactNode } from 'react'
import { TerminalErrorCode, RecoverableErrorCode } from './checkout'
import { TopazError } from './errors'

export interface RecoverableTerminalErrorsNotification {
  heading: ReactNode
  message: ReactNode
  severe: boolean
}

export interface RecoverableCurrentError {
  error: TerminalErrorCode | RecoverableErrorCode | string
  errorCode?: ErrorCode | TopazError
}

export interface InitiateMutationResponse {
  data: InitiateInstallmentPaymentResponse
  isInitiateLoading: boolean
  isInitiateSuccess: boolean
  isError: boolean
}

export const isOverdueResponseType = (selectedOrder?: OrderResponse | OverduePaymentResponse): selectedOrder is OverduePaymentResponse =>
  'overduePaymentSchedules' in (selectedOrder ?? {})
